import * as React from "react"

import { ReactComponent as DashboardSvg } from 'resources/icons/view/dash_solid.svg'

import FeatureList from './c/FeatureList/FeatureList'

import * as st from './Visibility.styled.js'

const Visibility = () => (
  <st.Wrap
    color="green"
    Icon={DashboardSvg}
    isTopLine
  >
    <st.Content>
      <st.TitleWrap>
        <st.Title>
          <ins>Full visibility</ins> into all aspects of projects
        </st.Title>
      </st.TitleWrap>
      <FeatureList />
    </st.Content>
  </st.Wrap>
)

export default Visibility
